import { IPoolType } from '@features/game/types/fast-game';
import { components } from '@features/shared/api/fastgames/clients';

interface IClockSettings {
  clockControlType: components['schemas']['ClockControlType'];
  clockControlSettings: components['schemas']['ClockControlSettings'];
}

export interface ITimeControlOption {
  id: IPoolType;
  clock: IClockSettings;
  label: string;
  typeLabel: string;
}

export const TIME_CONTROLS: ITimeControlOption[] = [
  {
    id: 'Bullet1Plus0',
    label: '1+0',
    typeLabel: 'Пуля',
    clock: {
      clockControlType: 'Bullet',
      clockControlSettings: {
        firstMoveSeconds: -1,
        initialSeconds: 1 * 60,
        addSecondsPerMove: 0,
      },
    },
  },
  {
    id: 'Blitz3Plus0',
    label: '3+0',
    typeLabel: 'Блиц',
    clock: {
      clockControlType: 'Blitz',
      clockControlSettings: {
        firstMoveSeconds: -1,
        initialSeconds: 3 * 60,
        addSecondsPerMove: 0,
      },
    },
  },
  {
    id: 'Blitz3Plus2',
    label: '3+2',
    typeLabel: 'Блиц',
    clock: {
      clockControlType: 'Blitz',
      clockControlSettings: {
        firstMoveSeconds: -1,
        initialSeconds: 3 * 60,
        addSecondsPerMove: 2,
      },
    },
  },
  {
    id: 'Blitz5Plus0',
    label: '5+0',
    typeLabel: 'Блиц',
    clock: {
      clockControlType: 'Blitz',
      clockControlSettings: {
        firstMoveSeconds: -1,
        initialSeconds: 5 * 60,
        addSecondsPerMove: 0,
      },
    },
  },
  {
    id: 'Blitz5Plus3',
    label: '5+3',
    typeLabel: 'Блиц',
    clock: {
      clockControlType: 'Blitz',
      clockControlSettings: {
        firstMoveSeconds: -1,
        initialSeconds: 5 * 60,
        addSecondsPerMove: 3,
      },
    },
  },
  {
    id: 'Rapid10Plus0',
    label: '10+0',
    typeLabel: 'Рапид',
    clock: {
      clockControlType: 'Rapid',
      clockControlSettings: {
        firstMoveSeconds: -1,
        initialSeconds: 10 * 60,
        addSecondsPerMove: 0,
      },
    },
  },
  {
    id: 'Rapid10Plus5',
    label: '10+5',
    typeLabel: 'Рапид',
    clock: {
      clockControlType: 'Rapid',
      clockControlSettings: {
        firstMoveSeconds: -1,
        initialSeconds: 10 * 60,
        addSecondsPerMove: 5,
      },
    },
  },
];
